module.exports = __webpack_public_path__ + "home-partner-image-quality.1WuBZaDL.svg";